export default __webpack_public_path__ + "static/media/login_art.818c3a56.png";